import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterTaxableEarningsView.
 * @extends JetView
 */
export default class FilterTaxableEarningsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'CreatedLocalDate',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Label for date input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            height: document.body.offsetWidth < 500 ? 150 : 0, // Conditional height based on screen width
                            cols: [
                                {
                                    view: 'radio', // Radio buttons for user type selection
                                    name: 'TypeUser',
                                    label: _('Tipo de Usuario'), // Label for radio buttons
                                    labelPosition: 'top',
                                    value: 0, // Default selected value
                                    options: [
                                        { id: 0, value: _('Todos') }, // Option for all users
                                        {
                                            id: 1,
                                            value: "<span class='icon-players'></span> ", // Option for player type
                                        },
                                        {
                                            id: 2,
                                            value: "<span class='icon-shop'></span>", // Option for shop type
                                        },
                                    ],
                                },
                                { id: 'grav2', gravity: 1 }, // Gravity for layout adjustment
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 360 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout adjustment
                        {
                            view: 'button', // Button for clearing the form
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values on click
                            },
                        },
                        {
                            view: 'button', // Button for submitting the form
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for submission
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('taxableEarnings:filter', [filterdata]); // Trigger filter event with form data
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Including upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
